// extracted by mini-css-extract-plugin
export var centered = "_m-6";
export var flexible = "_m-5";
export var footer = "_m-k";
export var footerBorder = "_m-l";
export var header = "_m-c";
export var headerBorder = "_m-d";
export var headerDefault = "_m-g";
export var headerMedium = "_m-h";
export var headerPadding = "_m-e";
export var iconAndTitle = "_m-f";
export var large = "_m-4";
export var largePadding = "_m-a";
export var medium = "_m-3";
export var mediumPadding = "_m-9";
export var modal = "_m-0";
export var modalContainer = "_m-b";
export var noPadding = "_m-7";
export var skinny = "_m-1";
export var small = "_m-2";
export var smallPadding = "_m-8";
export var subtitle = "_m-j";
export var title = "_m-i";